export const FETCH_DASHBOARD_REQUEST = 'FETCH_DASHBOARD_REQUEST';
export const FETCH_DASHBOARD_REQUEST_COMPLETED = 'FETCH_DASHBOARD_REQUEST_COMPLETED';
export const FETCH_DASHBOARD_REQUEST_ERROR = 'FETCH_DASHBOARD_REQUEST_ERROR';
export const FETCH_DASHBOARD_RESET = 'FETCH_DASHBOARD_RESET';





// WEBPACK FOOTER //
// ./constants/dashboarddetails.js